module.exports = __webpack_public_path__ + "img/img78.44daa09c.png";